export default "__VITE_ASSET__DZVrtYzx__"